module.exports = "tr.header {\n  font-weight: bold;\n  font-size: 16px;\n  color: white;\n  background: #333; }\n\nthead {\n  font-weight: bold; }\n"